import React, { useCallback } from 'react';
import { ToggleButtons } from '@components/ToggleButtons';
import {
  useSubscriptions,
  useSubscriptionsDispatch,
} from '@features/subscriptions/context/subscription-context';
import { FlexView } from '@goodfynd/ui';
import { addClassNames } from '@goodfynd/theme';
import { Text } from '@goodfynd/ui';
import type { SubscriptionFrequency } from 'types/account/subscriptions';

import { SubscriptionProduct } from './SubscriptionProduct';
import type { SubscriptionProductsProps } from './types';

import classes from './SubscriptionProducts.module.css';

export const SubscriptionProducts = ({
  className,
}: SubscriptionProductsProps) => {
  const {
    cart,
    hasActiveSubscriptions,
    products: subscriptions,
  } = useSubscriptions();
  const { setFrequency } = useSubscriptionsDispatch();

  const renderProducts = useCallback(() => {
    return subscriptions.map((subscription) => (
      <SubscriptionProduct
        frequency={cart.frequency}
        key={subscription.stripeId}
        lineItem={cart.items.find((item) => item.sku === subscription.sku)}
        product={subscription}
      />
    ));
  }, [cart.frequency, cart.items, subscriptions]);

  return (
    <div className={addClassNames(classes.container, className)}>
      <FlexView justify="space-between">
        <Text as="sectionHeader">Add-ons</Text>

        {!hasActiveSubscriptions && (
          <ToggleButtons<SubscriptionFrequency>
            value={cart.frequency}
            onChange={(value) => {
              setFrequency(value);
            }}
            options={[
              {
                label: 'Monthly',
                value: 'monthly',
              },
              {
                label: 'Annually',
                value: 'annual',
              },
            ]}
          />
        )}
      </FlexView>

      <FlexView direction="column" fullWidth gap={16}>
        {renderProducts()}
      </FlexView>
    </div>
  );
};
